import { useThemeContext } from '../providers/ThemeProvider';

export function useTheme() {
  const { theme, isDark, themeMode, setThemeMode } = useThemeContext();

  return {
    theme,
    isDark,
    themeMode,
    setThemeMode,
  };
}
